// src/store/slices/atelier.slice.js

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  ateliers: [],
  reservationCounts: {},
};

const atelierSlice = createSlice({
  name: 'atelier',
  initialState,
  reducers: {
    setAteliers: (state, { payload }) => {
      state.ateliers = payload;
    },
    updateReservationCount: (state, { payload }) => {
      const { atelierId, count } = payload;
      state.reservationCounts[atelierId] = count;
    },
    setReservationCounts: (state, { payload }) => {
      state.reservationCounts = payload;
    },
    incrementReservationCount: (state, { payload }) => {
      const { atelierId } = payload;
      if (state.reservationCounts[atelierId]) {
        state.reservationCounts[atelierId] += 1;
      } else {
        state.reservationCounts[atelierId] = 1;
      }
    },
    decrementReservationCount: (state, { payload }) => {
      const { atelierId } = payload;
      if (state.reservationCounts[atelierId] && state.reservationCounts[atelierId] > 0) {
        state.reservationCounts[atelierId] -= 1;
      }
    },
  },
});

// Export des actions
export const { 
  setAteliers, 
  updateReservationCount, 
  setReservationCounts,
  incrementReservationCount,
  decrementReservationCount
} = atelierSlice.actions;

// Export des sélecteurs
export const selectAteliers = state => state.atelier.ateliers;
export const selectReservationCounts = state => state.atelier.reservationCounts;
export const selectReservationCountByAtelierId = (state, atelierId) => 
  state.atelier.reservationCounts[atelierId] || 0;
export const selectAtelierById = (state, atelierId) => 
  state.atelier.ateliers.find(atelier => atelier.id === atelierId);

export default atelierSlice.reducer;